module.exports = __webpack_public_path__ + "img/1487657926.63ee580f.jpg";